import { createStructuredSelector } from 'reselect';
import {
  selectAvailableBalance,
  selectCurrentBalance,
  selectApplicableBusinessFunction
} from '../../../../../selectors/globalSelectors';
import {
  selectCharityId,
  selectCharityInterest,
  selectPurposeId,
  selectAdditionalComments,
  selectMissionaryName,
  selectEventName,
  selectMissionaryLocation,
  selectProjectName,
  selectPurposeCertification,
  selectStandardLanguage,
  selectHonorOf,
  selectMemoryOf,
  selectNotifyFirstName,
  selectNotifyLastName,
  selectThirdParty,
  selectAccountName,
  selectIncludeAdvisorInfo,
  selectPublishName,
  selectFrequency,
  selectAllocations,
  selectAllSharesAllPools,
  selectAllShares
} from './ConfirmationPageSelectors';
import {
  fetchRAGState,
  selectSelectedCharityName,
  selectSelectedCharityEin,
  selectGrantRecognition,
  selectGrantAmount,
  selectStartDate,
  selectNoOfPayments,
  selectScheduleType,
  selectAllocationType
} from './RecommendGrantPageSelectors';

export const selectGrantId = (state) => {
  const { grantId } = fetchRAGState(state);
  return grantId;
};

export const selectScheduleId = (state) => {
  const { scheduleId } = fetchRAGState(state);
  return scheduleId;
};

export const selectUpdateReq = (state) => {
  const { updateReq } = fetchRAGState(state);
  return updateReq;
};

export const selectUpdateErrors = (state) => {
  const { updateErrors } = fetchRAGState(state);
  return updateErrors;
};

export const selectPendingSpawnId = (state) => {
  const { pendingSpawnId } = fetchRAGState(state);
  return pendingSpawnId;
};

export const selectScheduleStatus = (state) => {
  const { scheduleStatus } = fetchRAGState(state);
  return scheduleStatus;
};

export const editGrantDerivedStates = createStructuredSelector({
  availableBalance: selectAvailableBalance,
  currentBalance: selectCurrentBalance,
  charityId: selectCharityId,
  charityName: selectSelectedCharityName,
  charityEin: selectSelectedCharityEin,
  charityInterest: selectCharityInterest,
  purposeId: selectPurposeId,
  additionalComments: selectAdditionalComments,
  missionaryName: selectMissionaryName,
  eventName: selectEventName,
  missionaryLocation: selectMissionaryLocation,
  projectName: selectProjectName,
  purposeCertification: selectPurposeCertification,
  standardLanguage: selectStandardLanguage,
  grantRecognition: selectGrantRecognition,
  inHonorOfName: selectHonorOf,
  inMemoryOfName: selectMemoryOf,
  notifyFirstName: selectNotifyFirstName,
  notifyLastName: selectNotifyLastName,
  thirdParty: selectThirdParty,
  accountName: selectAccountName,
  includeAdvisorInfo: selectIncludeAdvisorInfo,
  publishName: selectPublishName,
  grantAmount: selectGrantAmount,
  startDate: selectStartDate,
  frequency: selectFrequency,
  noOfPayments: selectNoOfPayments,
  scheduleType: selectScheduleType,
  amountType: selectAllocationType,
  allocations: selectAllocations,
  allSharesAllPools: selectAllSharesAllPools,
  allShares: selectAllShares,
  grantId: selectGrantId,
  scheduleId: selectScheduleId,
  updateReq: selectUpdateReq,
  updateErrors: selectUpdateErrors,
  pendingSpawnId: selectPendingSpawnId,
  scheduleStatus: selectScheduleStatus,
  applicable_business_function: selectApplicableBusinessFunction,
});
